import '../common/base';
import HomePage from '../components/core/home/HomePage';
import Vue from '../common/vue-common';

new Vue({
    render: (h) => h(HomePage),
}).$mount('#app');
